<mat-dialog-content><p>Du behöver ansluta till Google för att kunna fortsätta.</p></mat-dialog-content>
<mat-dialog-actions class="dual">
    <button mat-button color="primary" (click)="connect()">Anslut till Google</button>
    <button mat-button color="warn" mat-dialog-close i18n>Avbryt</button>
</mat-dialog-actions>